"use client";

import PracticeSelector from "@/components/ui/practice-selector";

import Buttons from "../../components/buttons";
import { useWizard } from "../../context";
import styles from "../index.module.scss";

export default function StepOne() {
  const { state, trial, actions } = useWizard();

  actions.goBackCheck(1);

  return (
    <>
      <p className="text-style-body2-regular mt-2">
        Please select a study location you would like to participate at for {trial.name}.
      </p>
      <div className={styles.container}>
        <PracticeSelector
          enableGeo={true}
          practices={trial.practices}
          selected={state.data.trialPractice}
          onSelect={({ id, name }) =>
            actions.setData({
              trialPractice: {
                id,
                name,
              },
            })
          }
        />
        <Buttons disabled={!state.data.trialPractice} className={styles.buttons} />
      </div>
    </>
  );
}
